import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  addNewSelfLaunchDone,
  addNewSelfLaunchError,
  addNewSelfLaunchLoading,
  addNewSelfLaunchSuccess,
  fetchSelfLaunchListDone,
  fetchSelfLaunchListError,
  fetchSelfLaunchListLoading,
  fetchSelfLaunchListSuccess,
  removeSelfLaunchDone,
  removeSelfLaunchError,
  removeSelfLaunchLoading,
  removeSelfLaunchSuccess
} from '../actions/selfLaunchAllowed';
import { adminApi } from '../api/AdminApi';
import {
  ADD_NEW_SELF_LAUNCH,
  FETCH_SELF_LAUNCH_LIST,
  REMOVE_SELF_LAUNCH
} from '../actions/actionTypes';

export function* watchFetchSelfLaunchListSaga () {
  yield takeLatest(FETCH_SELF_LAUNCH_LIST, fetchSelfLaunchListSaga);
}

export function* fetchSelfLaunchListSaga ({ tenantId }) {
  try {
    yield put(fetchSelfLaunchListLoading());
    const heroes = yield call(adminApi.fetchWhitelist, tenantId);
    yield put(fetchSelfLaunchListSuccess(heroes));
  } catch (error) {
    yield put(fetchSelfLaunchListError(error));
  } finally {
    yield put(fetchSelfLaunchListDone());
  }
}

export function* watchAddNewSelfLaunchListSaga () {
  yield takeLatest(ADD_NEW_SELF_LAUNCH, addNewSelfLaunchSaga);
}

export function* addNewSelfLaunchSaga ({ tenantId, emails }) {
  try {
    yield put(addNewSelfLaunchLoading());
    const heroes = yield call(adminApi.addNewAuthorizedCreators, tenantId, emails);
    yield put(addNewSelfLaunchSuccess(heroes));
  } catch (error) {
    yield put(addNewSelfLaunchError(error));
  } finally {
    yield put(addNewSelfLaunchDone());
  }
}

export function* watchRemoveSelfLaunchSaga () {
  yield takeLatest(REMOVE_SELF_LAUNCH, removeSelfLaunchSaga);
}

export function* removeSelfLaunchSaga ({ tenantId, idOrEmail }) {
  try {
    yield put(removeSelfLaunchLoading());
    const heroes = yield call(adminApi.removeAuthorizedCreator, tenantId, idOrEmail);
    yield put(removeSelfLaunchSuccess(heroes));
  } catch (error) {
    yield put(removeSelfLaunchError(error));
  } finally {
    yield put(removeSelfLaunchDone());
  }
}

export default [
  fork(watchFetchSelfLaunchListSaga),
  fork(watchRemoveSelfLaunchSaga),
  fork(watchAddNewSelfLaunchListSaga)
];
